<template>
  <a-row class="controls" type="flex" justify="space-between">
    <a-col>
      <TableControlsSkeleton :count="countFilterLoading" width="200px" v-if="localLoading" style="margin-right: 20px"/>
      <a-form layout="inline" v-else>
        <a-form-item>
          <a-input
            v-model:value="filters.search"
            class="input"
            placeholder="Buscar por nombre de cola"
          >
            <template #prefix>
              <SearchOutlined />
            </template>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="filters.portfolio"
            class="input"
          >
            <a-select-option :key="0"> Todos las campañas </a-select-option>
            <a-select-option v-for="portfolio in portfolios" :key="portfolio.id">
              {{ portfolio.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-col>
    <a-col>
      <a-button type="primary" id="add-new-queue" @click="handleShowAddModal">
        Crear nueva cola
      </a-button>
      <queues-add-modal
        ref="add"
        :value="addModal"
        @update="$emit('update')"
        @closeModal="addModal = false"
      />
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, inject, ref } from "vue";
import { SearchOutlined } from "@ant-design/icons-vue";

import { QueuesEvent } from "@/app/queues/domain/events";

import QueuesAddModal from "@/app/queues/components/modals/QueuesAddModal.vue";
import EventBus from "@/app/shared/utils/eventBus";
import TableControlsSkeleton from "@/app/shared/components/skeletons/TableControlsSkeleton.vue";

export default defineComponent({
  components: {
    QueuesAddModal,
    SearchOutlined,
    TableControlsSkeleton,
  },
  data() {
    return {
      addModal: false,
      loading: false,
    };
  },
  setup() {
    const filters = inject("filters");
    const countFilterLoading = ref(2);
    return { filters, countFilterLoading };
  },
  mounted() {
    this.$store.dispatch("fetchAllPortfoliosByEntity");
  },
  methods: {
    handleShowAddModal() {
      this.addModal = true;
      EventBus.$emit(QueuesEvent.QUEUE_MODAL_ADD_OPENED);
    },
  },
  computed: {
    portfolios() {
      this.localLoading = true;
      const portfolio = this.$store.getters["getFilteredPortfolios"];
      this.localLoading = false;
      return portfolio;
    },
  },
});
</script>

<style lang="sass" scoped>
.input
  width: 280px !important
</style>
